import { createSlice } from '@reduxjs/toolkit'

export const WishListStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: WishListStatus.LOADING,
    wishList: {
        course: [],
        class: [],
    },
    errorMessage: null,
}

const wishListSlice = createSlice({
    name: 'wishlist',
    initialState,
    reducers: {
        getWishListRequest: state => {
            state.status = WishListStatus.LOADING
        },
        getWishListRequestSuccess: (state, action) => {
            state.status = WishListStatus.SUCCESS
            const wishList = {
                course: [],
                class: [],
            }
            action.payload.forEach(item => {
                wishList[item.wishlistItem].push(item)
            })
            state.wishList = wishList
        },
        getWishListRequestError: (state, action) => {
            state.status = WishListStatus.FAILURE
            state.errorMessage = action.payload
        },
        removeFromWishlist: (state, action) => {
            const { type, itemId } = action.payload
            if (type === 'course') {
                state.wishList = {
                    ...state.wishList,
                    course: state.wishList.course.filter(
                        ({ id }) => id !== itemId
                    ),
                }
            } else {
                state.wishList = {
                    ...state.wishList,
                    class: state.wishList.class.filter(
                        ({ id }) => String(id) !== String(itemId)
                    ),
                }
            }
        },
        addToWishList: (state, action) => {
            const { item, type } = action.payload

            const items = state.wishList[type]

            if (items.some(({ id }) => id === item.id)) {
                //If item already exist don't add it again
                return
            }

            items.push(item)

            state.wishList = {
                ...state.wishList,
                [type]: items,
            }
        },
    },
})

const {
    getWishListRequest,
    getWishListRequestSuccess,
    getWishListRequestError,
    removeFromWishlist,
    addToWishList,
} = wishListSlice.actions

export const wishListActions = {
    getWishListRequest,
    getWishListRequestSuccess,
    getWishListRequestError,
    removeFromWishlist,
    addToWishList,
}

export const wishListSelectors = {
    hasError: state => state.wishList.status === WishListStatus.FAILURE,
    isFetching: state => state.wishList.status === WishListStatus.LOADING,
    courses: state => state.wishList.wishList.course,
    classes: state => state.wishList.wishList.class,
    errorMessage: state => state.wishList.errorMessage,
}

const wishListReducer = wishListSlice.reducer

export default wishListReducer
